import { initOembedContainers } from 'Shared/remote_embed';
import { Modal } from 'Shared/modal';

initOembedContainers();

onDomReady(() => {
   $$('.js-add-image-modal').each(el => {
      el.addEvent('click', function (ev) {
         ev.stop();
         let imgUrl = this.get('data-modalImg');
         Modal.openModalImg(imgUrl);
      });
   });

   $$('.js-thumbnail-image').addEvent('mouseenter', ev => {
      let imageid = ev.target.get('data-imageid');
      $$('.js-main-image').hide();
      $('image-' + imageid).show();
   });
});
